import { createContext, useContext } from "react";

export const AdminNotificationsContext = createContext({
  newSignupCount: 0,
  markSignupRequestsSeen: () => {},
});

export const useAdminNotifications = () => useContext(AdminNotificationsContext);